import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_BEGIN,
  DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_SUCCESS,
  DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_FAILURE,
  DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function requestUpgradeAccount(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_BEGIN,
    });
    const { projectId, code } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}projects/core/${projectId}/upgrade-account`,
        { projectId, code },
        header,
      );
      doRequest.then(
        (res) => {
          const { data, status } = res;
          if (status === 200) {
            dispatch({
              type: DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_SUCCESS,
              data: res.data,
            });
            toast.success(data.message, {});
            resolve(res);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_FAILURE,
              data: { error: data.message },
            });
            toast.error(`Error: ${data.message}`);
            reject(err);
          }
        },
        (err) => {
          const { response } = err;
          dispatch({
            type: DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_FAILURE,
            data: { error: err },
          });

          if (response && response.data && response.data.message) {
            toast.error(`Error: ${response.data.message}`);
          } else {
            toast.error(`Error: Failed to send mail to Admin.`);
          }
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissRequestUpgradeAccountError() {
  return {
    type: DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_BEGIN:
      return {
        ...state,
        requestUpgradeAccountPending: true,
        requestUpgradeAccountError: null,
      };

    case DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_SUCCESS:
      return {
        ...state,
        requestUpgradeAccountPending: false,
        requestUpgradeAccountError: null,
      };

    case DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_FAILURE:
      return {
        ...state,
        requestUpgradeAccountPending: false,
        requestUpgradeAccountError: action.data.error,
      };

    case DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_DISMISS_ERROR:
      return {
        ...state,
        requestUpgradeAccountError: null,
      };

    default:
      return state;
  }
}
